import React from "react";
import Title from "../../../components/Title/Title";
import './SponsorsPage.scss';
import EPFLLogo from "../../../assets/epfl-logo.svg";
import DescoLogo from "../../../assets/desco-logo-blk.svg";

const Sponsors2026page = () => {
    return (
        <div>
            <Title>Sponsors</Title>
            <p>
                TBD
            </p>
        </div>
    );
}

export default Sponsors2026page
